import React from "react";

export const Iconography: React.FC = () => {
  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text);
    // Could add a toast notification here
  };

  const drawingTools = [
    {
      name: "SelectionIcon",
      usage: "Default selection tool",
      svg: (
        <svg
          aria-hidden="true"
          focusable="false"
          role="img"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M6 6l4.153 11.793a0.365 .365 0 0 0 .331 .207a0.366 .366 0 0 0 .332 -.207l2.184 -4.793l4.787 -1.994a0.355 .355 0 0 0 .213 -.323a0.355 .355 0 0 0 -.213 -.323l-11.787 -4.36z" />
          <path d="M13.5 13.5l4.5 4.5" />
        </svg>
      ),
    },
    {
      name: "RectangleIcon",
      usage: "Rectangle drawing tool",
      svg: (
        <svg
          aria-hidden="true"
          focusable="false"
          role="img"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <rect x="4" y="4" width="16" height="16" rx="2" />
        </svg>
      ),
    },
    {
      name: "DiamondIcon",
      usage: "Diamond drawing tool",
      svg: (
        <svg
          aria-hidden="true"
          focusable="false"
          role="img"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M10.5 20.4l-6.9 -6.9c-.781 -.781 -.781 -2.219 0 -3l6.9 -6.9c.781 -.781 2.219 -.781 3 0l6.9 6.9c.781 .781 .781 2.219 0 3l-6.9 6.9c-.781 .781 -2.219 .781 -3 0z" />
        </svg>
      ),
    },
    {
      name: "EllipseIcon",
      usage: "Circle/ellipse drawing tool",
      svg: (
        <svg
          aria-hidden="true"
          focusable="false"
          role="img"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <circle cx="12" cy="12" r="9" />
        </svg>
      ),
    },
    {
      name: "ArrowIcon",
      usage: "Arrow drawing tool",
      svg: (
        <svg
          aria-hidden="true"
          focusable="false"
          role="img"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <line x1="5" y1="12" x2="19" y2="12" />
          <line x1="15" y1="16" x2="19" y2="12" />
          <line x1="15" y1="8" x2="19" y2="12" />
        </svg>
      ),
    },
    {
      name: "LineIcon",
      usage: "Line drawing tool",
      svg: (
        <svg
          aria-hidden="true"
          focusable="false"
          role="img"
          viewBox="0 0 20 20"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M4.167 10h11.666" />
        </svg>
      ),
    },
    {
      name: "FreedrawIcon",
      usage: "Freehand drawing tool",
      svg: (
        <svg
          aria-hidden="true"
          focusable="false"
          role="img"
          viewBox="0 0 20 20"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path
            clipRule="evenodd"
            d="m7.643 15.69 7.774-7.773a2.357 2.357 0 1 0-3.334-3.334L4.31 12.357a3.333 3.333 0 0 0-.977 2.357v1.953h1.953c.884 0 1.732-.352 2.357-.977Z"
          />
          <path d="m11.25 5.417 3.333 3.333" />
        </svg>
      ),
    },
    {
      name: "TextIcon",
      usage: "Text tool",
      svg: (
        <svg
          aria-hidden="true"
          focusable="false"
          role="img"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <line x1="4" y1="20" x2="7" y2="20" />
          <line x1="14" y1="20" x2="21" y2="20" />
          <line x1="6.9" y1="15" x2="13.8" y2="15" />
          <line x1="10.2" y1="6.3" x2="16" y2="20" />
          <polyline points="5 20 11 4 13 4 20 20" />
        </svg>
      ),
    },
    {
      name: "ImageIcon",
      usage: "Image insertion tool",
      svg: (
        <svg
          aria-hidden="true"
          focusable="false"
          role="img"
          viewBox="0 0 20 20"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M12.5 6.667h.01" />
          <path d="M4.91 2.625h10.18a2.284 2.284 0 0 1 2.285 2.284v10.182a2.284 2.284 0 0 1-2.284 2.284H4.909a2.284 2.284 0 0 1-2.284-2.284V4.909a2.284 2.284 0 0 1 2.284-2.284Z" />
          <path d="m3.333 12.5 3.334-3.333c.773-.745 1.726-.745 2.5 0l4.166 4.166" />
          <path d="m11.667 11.667.833-.834c.774-.744 1.726-.744 2.5 0l1.667 1.667" />
        </svg>
      ),
    },
    {
      name: "EraserIcon",
      usage: "Eraser tool",
      svg: (
        <svg
          aria-hidden="true"
          focusable="false"
          role="img"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M19 20h-10.5l-4.21 -4.3a1 1 0 0 1 0 -1.41l10 -10a1 1 0 0 1 1.41 0l5 5a1 1 0 0 1 0 1.41l-9.2 9.3" />
          <path d="M18 13.3l-6.3 -6.3" />
        </svg>
      ),
    },
  ];

  const uiActions = [
    {
      name: "PlusIcon",
      usage: "Add/create new",
      svg: (
        <svg
          aria-hidden="true"
          focusable="false"
          role="img"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <line x1="12" y1="5" x2="12" y2="19" />
          <line x1="5" y1="12" x2="19" y2="12" />
        </svg>
      ),
    },
    {
      name: "TrashIcon",
      usage: "Delete/remove",
      svg: (
        <svg
          aria-hidden="true"
          focusable="false"
          role="img"
          viewBox="0 0 20 20"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M3.333 5.833h13.334M8.333 9.167v5M11.667 9.167v5M4.167 5.833l.833 10c0 .92.746 1.667 1.667 1.667h6.666c.92 0 1.667-.746 1.667-1.667l.833-10M7.5 5.833v-2.5c0-.46.373-.833.833-.833h3.334c.46 0 .833.373.833.833v2.5" />
        </svg>
      ),
    },
    {
      name: "DuplicateIcon",
      usage: "Duplicate/copy",
      svg: (
        <svg
          aria-hidden="true"
          focusable="false"
          role="img"
          viewBox="0 0 20 20"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M14.375 6.458H8.958a2.5 2.5 0 0 0-2.5 2.5v5.417a2.5 2.5 0 0 0 2.5 2.5h5.417a2.5 2.5 0 0 0 2.5-2.5V8.958a2.5 2.5 0 0 0-2.5-2.5Z" />
          <path
            clipRule="evenodd"
            d="M11.667 3.125c.517 0 .986.21 1.325.55.34.338.55.807.55 1.325v1.458H8.333c-.485 0-.927.185-1.26.487-.343.312-.57.75-.609 1.24l-.005 5.357H5a1.87 1.87 0 0 1-1.326-.55 1.87 1.87 0 0 1-.549-1.325V5c0-.518.21-.987.55-1.326.338-.34.807-.549 1.325-.549h6.667Z"
          />
        </svg>
      ),
    },
    {
      name: "ExportIcon",
      usage: "Export/download",
      svg: (
        <svg
          aria-hidden="true"
          focusable="false"
          role="img"
          viewBox="0 0 20 20"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M3.333 14.167v1.666c0 .92.747 1.667 1.667 1.667h10c.92 0 1.667-.746 1.667-1.667v-1.666M5.833 9.167 10 13.333l4.167-4.166M10 3.333v10" />
        </svg>
      ),
    },
    {
      name: "LibraryIcon",
      usage: "Library/components",
      svg: (
        <svg
          aria-hidden="true"
          focusable="false"
          role="img"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M3 19a9 9 0 0 1 9 0a9 9 0 0 1 9 0" />
          <path d="M3 6a9 9 0 0 1 9 0a9 9 0 0 1 9 0" />
          <line x1="3" y1="6" x2="3" y2="19" />
          <line x1="12" y1="6" x2="12" y2="19" />
          <line x1="21" y1="6" x2="21" y2="19" />
        </svg>
      ),
    },
    {
      name: "HamburgerMenuIcon",
      usage: "Menu/navigation",
      svg: (
        <svg
          aria-hidden="true"
          focusable="false"
          role="img"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <line x1="4" y1="6" x2="20" y2="6" />
          <line x1="4" y1="12" x2="20" y2="12" />
          <line x1="4" y1="18" x2="20" y2="18" />
        </svg>
      ),
    },
  ];

  const zoomIcons = [
    {
      name: "ZoomInIcon",
      usage: "Zoom in",
      svg: (
        <svg
          aria-hidden="true"
          focusable="false"
          role="img"
          viewBox="0 0 20 20"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M10 4.167v11.666M4.167 10h11.666" />
        </svg>
      ),
    },
    {
      name: "ZoomOutIcon",
      usage: "Zoom out",
      svg: (
        <svg
          aria-hidden="true"
          focusable="false"
          role="img"
          viewBox="0 0 20 20"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M5 10h10" />
        </svg>
      ),
    },
    {
      name: "ZoomResetIcon",
      usage: "Reset zoom to fit",
      svg: (
        <svg
          aria-hidden="true"
          focusable="false"
          role="img"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M21 21l-6 -6" />
          <path d="M3.268 12.043a7.017 7.017 0 0 0 6.634 4.957a7.012 7.012 0 0 0 7.043 -6.131a7 7 0 0 0 -5.314 -7.672a7.021 7.021 0 0 0 -8.241 4.403" />
          <path d="M3 4v4h4" />
        </svg>
      ),
    },
  ];

  const themeIcons = [
    {
      name: "SunIcon",
      usage: "Light mode",
      svg: (
        <svg
          aria-hidden="true"
          focusable="false"
          role="img"
          viewBox="0 0 20 20"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M10 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM10 4.167V2.5M14.167 5.833l1.166-1.166M15.833 10H17.5M14.167 14.167l1.166 1.166M10 15.833V17.5M5.833 14.167l-1.166 1.166M5 10H3.333M5.833 5.833 4.667 4.667" />
        </svg>
      ),
    },
    {
      name: "MoonIcon",
      usage: "Dark mode",
      svg: (
        <svg
          aria-hidden="true"
          focusable="false"
          role="img"
          viewBox="0 0 20 20"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path
            clipRule="evenodd"
            d="M10 2.5h.328a6.25 6.25 0 0 0 6.6 10.372A7.5 7.5 0 1 1 10 2.493V2.5Z"
          />
        </svg>
      ),
    },
  ];

  const IconGrid: React.FC<{ icons: typeof drawingTools }> = ({ icons }) => (
    <div className="icon-grid">
      {icons.map((icon, index) => (
        <div key={index} className="icon-item">
          <div className="icon-preview">{icon.svg}</div>
          <div className="icon-name">{icon.name}</div>
          <div className="icon-usage">{icon.usage}</div>
        </div>
      ))}
    </div>
  );

  return (
    <div className="ds-section">
      <div className="ds-section-header">
        <h2>🎨 Iconography</h2>
        <p>
          Excalidraw uses a comprehensive icon system based on Tabler Icons and
          FontAwesome, with custom modifications for drawing tools and UI
          elements.
        </p>
      </div>

      {/* Drawing Tools */}
      <div className="icon-category">
        <h3 className="ds-section-title">Drawing Tools</h3>
        <IconGrid icons={drawingTools} />
      </div>

      {/* UI Actions */}
      <div className="icon-category">
        <h3 className="ds-section-title">UI Actions</h3>
        <IconGrid icons={uiActions} />
      </div>

      {/* Zoom & View */}
      <div className="icon-category">
        <h3 className="ds-section-title">Zoom & View</h3>
        <div className="icon-grid">
          {zoomIcons.map((icon) => (
            <div
              key={icon.name}
              className="icon-item"
              onClick={() => copyToClipboard(icon.name)}
            >
              <div className="icon-preview">{icon.svg}</div>
              <div className="icon-name">{icon.name}</div>
              <div className="icon-usage">{icon.usage}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Theme & Mode */}
      <div className="icon-category">
        <h3 className="ds-section-title">Theme & Mode</h3>
        <div className="icon-grid">
          {themeIcons.map((icon) => (
            <div
              key={icon.name}
              className="icon-item"
              onClick={() => copyToClipboard(icon.name)}
            >
              <div className="icon-preview">{icon.svg}</div>
              <div className="icon-name">{icon.name}</div>
              <div className="icon-usage">{icon.usage}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Usage Guidelines */}
      <div className="icon-category">
        <h3 className="ds-section-title">Usage Guidelines</h3>
        <div className="guidelines-grid">
          <div className="guideline-item">
            <h4>Icon System</h4>
            <p>
              Icons are created using the <code>createIcon</code> helper
              function with consistent sizing and stroke properties.
            </p>
            <div
              className="code-block"
              onClick={() =>
                copyToClipboard(
                  "export const MyIcon = createIcon(<svg>...</svg>, tablerIconProps);",
                )
              }
            >
              <code>
                export const MyIcon = createIcon(&lt;svg&gt;...&lt;/svg&gt;,
                tablerIconProps);
              </code>
            </div>
          </div>

          <div className="guideline-item">
            <h4>Standard Sizes</h4>
            <ul>
              <li>
                <strong>24x24px</strong> - Default Tabler icons
                (tablerIconProps)
              </li>
              <li>
                <strong>20x20px</strong> - Modified icons
                (modifiedTablerIconProps)
              </li>
              <li>
                <strong>Custom</strong> - Special icons with specific dimensions
              </li>
            </ul>
          </div>

          <div className="guideline-item">
            <h4>Stroke Properties</h4>
            <ul>
              <li>
                <strong>Stroke Width:</strong> 1.5px (standard), 1.25px
                (modified)
              </li>
              <li>
                <strong>Stroke Linecap:</strong> Round
              </li>
              <li>
                <strong>Stroke Linejoin:</strong> Round
              </li>
              <li>
                <strong>Fill:</strong> None (outline icons)
              </li>
            </ul>
          </div>

          <div className="guideline-item">
            <h4>Color Usage</h4>
            <p>
              Icons use <code>currentColor</code> to inherit text color from
              parent elements, ensuring proper theming support.
            </p>
            <div
              className="code-block"
              onClick={() =>
                copyToClipboard('stroke="currentColor" fill="currentColor"')
              }
            >
              <code>stroke="currentColor" fill="currentColor"</code>
            </div>
          </div>

          <div className="guideline-item">
            <h4>Accessibility</h4>
            <ul>
              <li>
                <strong>aria-hidden="true"</strong> - Decorative icons
              </li>
              <li>
                <strong>focusable="false"</strong> - Prevent keyboard focus
              </li>
              <li>
                <strong>role="img"</strong> - Semantic icons with labels
              </li>
            </ul>
          </div>

          <div className="guideline-item">
            <h4>RTL Support</h4>
            <p>
              Icons that should mirror in right-to-left languages use the{" "}
              <code>rtl-mirror</code> class or <code>mirror: true</code> option.
            </p>
          </div>
        </div>
      </div>

      {/* Icon Sources & Adding New Icons */}
      <div className="icon-category">
        <h3 className="ds-section-title">Icon Sources & Adding New Icons</h3>

        <div className="icon-sources-grid">
          <div className="source-item">
            <h4>📦 Primary Sources</h4>
            <div className="source-list">
              <div className="source-entry">
                <strong>Tabler Icons</strong>
                <span className="source-url">
                  →{" "}
                  <a
                    href="https://tabler-icons.io/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    tabler-icons.io
                  </a>
                </span>
                <p>
                  MIT Licensed • 4,000+ free SVG icons designed for web
                  interfaces
                </p>
                <div className="source-examples">
                  <span className="example-icon">🔲 Rectangle</span>
                  <span className="example-icon">⭕ Circle</span>
                  <span className="example-icon">➕ Plus</span>
                  <span className="example-icon">🗑️ Trash</span>
                </div>
              </div>

              <div className="source-entry">
                <strong>FontAwesome</strong>
                <span className="source-url">
                  →{" "}
                  <a
                    href="https://fontawesome.com/icons"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    fontawesome.com/icons
                  </a>
                </span>
                <p>
                  Various licenses • Referenced in header comments but mostly
                  using Tabler
                </p>
                <div className="source-examples">
                  <span className="example-icon">🌙 Moon</span>
                  <span className="example-icon">☀️ Sun</span>
                </div>
              </div>

              <div className="source-entry">
                <strong>Custom Icons</strong>
                <span className="source-url">
                  → Created specifically for Excalidraw
                </span>
                <p>
                  Custom designed • Handcrafted for specific drawing tools and
                  UI needs
                </p>
                <div className="source-examples">
                  <span className="example-icon">🎯 Selection</span>
                  <span className="example-icon">✏️ Freedraw</span>
                  <span className="example-icon">🔒 Lock variants</span>
                </div>
              </div>
            </div>
          </div>

          <div className="source-item">
            <h4>✅ Open Source & Free</h4>
            <div className="license-info">
              <div className="license-item">
                <strong>Tabler Icons:</strong> MIT License
                <p>
                  ✓ Free for commercial use
                  <br />✓ No attribution required
                  <br />✓ Modify and redistribute
                </p>
              </div>
              <div className="license-item">
                <strong>FontAwesome:</strong> Multiple licenses
                <p>
                  ✓ Free icons available
                  <br />✓ Check individual icon licenses
                  <br />✓ Some require attribution
                </p>
              </div>
              <div className="license-item">
                <strong>Custom Icons:</strong> Same as Excalidraw
                <p>
                  ✓ MIT License
                  <br />✓ Free to use and modify
                  <br />✓ Part of Excalidraw project
                </p>
              </div>
            </div>
          </div>

          <div className="source-item">
            <h4>🚀 Adding New Icons</h4>
            <div className="add-icons-guide">
              <div className="step-item">
                <strong>1. Choose Your Source</strong>
                <div
                  className="code-block"
                  onClick={() =>
                    copyToClipboard(
                      "// From Tabler Icons (recommended)\n// tabler-icons: icon-name",
                    )
                  }
                >
                  <code>
                    {/* From Tabler Icons (recommended) */}
                    <br />
                    {/* tabler-icons: icon-name */}
                  </code>
                </div>
              </div>

              <div className="step-item">
                <strong>2. Create the Icon</strong>
                <div
                  className="code-block"
                  onClick={() =>
                    copyToClipboard(
                      "export const NewIcon = createIcon(\n  <svg>...</svg>,\n  tablerIconProps\n);",
                    )
                  }
                >
                  <code>
                    export const NewIcon = createIcon(
                    <br />
                    &nbsp;&nbsp;&lt;svg&gt;...&lt;/svg&gt;,
                    <br />
                    &nbsp;&nbsp;tablerIconProps
                    <br />
                    );
                  </code>
                </div>
              </div>

              <div className="step-item">
                <strong>3. Follow Standards</strong>
                <ul>
                  <li>
                    Use <code>currentColor</code> for stroke/fill
                  </li>
                  <li>Include proper accessibility attributes</li>
                  <li>Test in both light and dark themes</li>
                  <li>Ensure consistent sizing</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
